const clientType = {
    FLASH_AIR : 'FLASH_AIR',

    FLASH_WEB : 'FLASH_WEB',

    IPAD_UW : 'IPAD_UW',

    OUTLOOK_PLUGIN : 'OUTLOOK_PLUGIN',

    UM_STUDIO : 'UM_STUDIO',

    UM_HTML_UW : 'UM_HTML_UW',

    UM_HTML_AGENT : 'UM_HTML_AGENT',

    APP_READER : 'APP_READER',

    OPERATOR : 'OPERATOR'

};

angular.module('gw-um-j2js')
    .constant('clientType', clientType);